import {TXY, TGetOthersResponse, getOthers, TFullNavObject} from "@ui/api/features"
import service from "@ui/services/features/OtherService"
import {LayerId} from "@ui/services/features"
import {Feature, TFeatureConstructorParams} from "./feature"
import {FeatureCollection, Geometry} from "geojson"

type TOthersConstructorParams = TFeatureConstructorParams

export class Other extends Feature {

  constructor(params: TOthersConstructorParams) {
    super(params)
  }

  async load(coords: TXY): Promise<void> {
    const others = await getOthers(coords)
    for (const type in others) {
      service.addFeatures(others[type as keyof TGetOthersResponse] as FeatureCollection<Geometry, TFullNavObject>, type as LayerId)
    }
  }

  toggle(isVisible: boolean) {
    service.toggleLayer(isVisible)
  }
}
